export default __webpack_public_path__ + "static/media/co2.06b61d28.svg";